<template>
<div id="app">

  <transition name="fade" mode="out-in">
    <router-view />
  </transition>

</div>
</template>

<script>
import axios from 'axios';
import FullNav from '@/components/FullNav.vue';

export default {
  name: 'Listing',
  components: {
    FullNav,
  },
  data() {
    return {
    };
  },
  created() {
  },
}
</script>

<style lang="scss">
@import 'assets/styles/app';

#app {
    font-family: Lato;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
